export default __webpack_public_path__ + "48964e9e689cf7cb6b6b0fb87d55f5dc.png";